import { money } from '../components/QuantityStepper'

/** Swaps the price shown in a buy-button label for the card's live total (base + add-ons). */
export function withPrice(label: string, total: number): string {
  const price = money(total)
  return /\$[\d,]+(\.\d{2})?/.test(label) ? label.replace(/\$[\d,]+(\.\d{2})?/, price) : `${label} — ${price}`
}
